'use strict';

/* globals define, $, socket, app */

define('userActivity', [], function () {
	var UserActivity = {};

	var internals = {
		customActivityInterval: null,
		refreshUsersActivityDataInterval: null,
	};

	UserActivity.init = function (data) {
		clearInterval(internals.refreshUsersActivityDataInterval);

		UserActivity.addCustomActivityData();
		UserActivity.refreshUsersActivityData(data);
	};

	UserActivity.refreshUsersActivityData = function (data) {
		if (!data || data.tpl_url !== 'chats') {
			return;
		}

		var usersToRefresh = $('.chats-list [data-uid]').map(function (index, el) {
			return parseInt($(el).attr('data-uid'), 10);
		});

		internals.refreshUsersActivityDataInterval = setInterval(function () {
			socket.emit('plugins.customChat.refreshUsersActivityData', usersToRefresh, function (err, usersActivityData) {
				if (err) {
					return;
				}

				$.each(usersActivityData, function (index, activityData) {
					if (!activityData) {
						return;
					}

					var chatWithUser = $('.chats-list [data-uid=' + activityData.uid + ']');

					chatWithUser.find('[data-status=\'offline\'] span.timeago').replaceWith('<span class="chat-timestamp timeago" title="' + activityData.lastActivityTimestampISO + '"></span>');

					$('.timeago').timeago();

					chatWithUser.find('[data-status=\'offline\']').css('display', activityData.isOnline ? 'none' : 'block');
					chatWithUser.find('[data-status=\'online\']').css('display', activityData.isOnline ? 'block' : 'none');
				});
			});
		}, 30000);
	};

	UserActivity.addCustomActivityData = function () {
		if (internals.customActivityInterval != null) {
			return;
		}

		UserActivity.runCustomActivityDataSocket();

		internals.customActivityInterval = setInterval(function () {
			UserActivity.runCustomActivityDataSocket();
		}, 30 * 1000);
	};

	UserActivity.runCustomActivityDataSocket = function () {
		if (app.user.uid === 0) {
			return;
		}

		socket.emit('plugins.customChat.addUserLastActivity', {});
	};

	return UserActivity;
});
